"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type UnsavedChangesDialogProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onDiscard: () => void;
  saveDisabled: boolean;
  isSaving: boolean;
};

export function UnsavedChangesDialog({
  open,
  onClose,
  onSave,
  onDiscard,
  saveDisabled,
  isSaving,
}: UnsavedChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-base">
            You have unsaved changes
          </DialogTitle>
          <DialogDescription>
            Your code has been modified. Do you want to keep the changes or
            discard them?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" className="mr-auto px-0" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="outline" onClick={onDiscard} disabled={isSaving}>
            Discard
          </Button>
          <Button disabled={saveDisabled} loading={isSaving} onClick={onSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
